export default {
  downloadFile: {
    url: '/file/download/auth',
    type: 'get'
  },
  getAccessoryToken: {
    // url: '/userauth/userLogin/getAccessoryToken',
    url: '/userauth/assist/getAccessoryToken',
    type: 'get'
  }
}
